import React from "react";
import {EmployeeStatus} from "@/data/entities/employee";
import {FormattedMessage} from "react-intl";
import {PlayCircleIcon} from "@heroicons/react/16/solid";

type Props = {
    employee: EmployeeStatus,
    isClockedIn: boolean,
};

const EmployeeIdentity = ({employee, isClockedIn}: Props) => {

    return (
        <div className={"flex flex-col p-6 border border-gray-200 dark:border-gray-700 rounded-xl"}>
            <div
                className={"w-full flex flex-row items-start justify-start border-b border-b-gray-200 dark:border-b-gray-700 pb-3 mb-6 gap-4"}
            >
                <div
                    className={"bg-blue-100 text-blue-900 dark:bg-blue-400/10 dark:text-blue-100 font-semibold rounded-full flex items-center justify-center size-[50px] shrink-0"}
                >
                    <span>{employee.firstName[0]}{employee.lastName[0]}</span>
                </div>

                <div>
                    <p className={"font-bold"}>
                        {employee.firstName}{" "}{employee.lastName}
                    </p>
                    <p className={"text-gray-600 dark:text-gray-400 text-[85%] flex flex-row items-center justify-start gap-1"}>
                        {
                            isClockedIn &&
                            <PlayCircleIcon className={"text-green-600 dark:text-green-400 animate-pulse size-3"}/>
                        }
                        <FormattedMessage id={isClockedIn ? "clockedIn" : "clockedOut"}/>
                    </p>
                </div>
            </div>

            <p className={"text-gray-500 dark:text-gray-400 text-[80%]"}>
                {employee.emailAddress || <FormattedMessage id={"no-email-address"}/>}
                {" • "}
                {employee.phoneNumber || <FormattedMessage id={"no-phone-number"}/>}
            </p>
        </div>
    );
};

export default EmployeeIdentity;